import styled from 'styled-components';
export const MobilePackshotContainer = styled.div.withConfig({
  displayName: "MobilePackshotstyle__MobilePackshotContainer",
  componentId: "sc-rnb2qz-0"
})(["", " .swiper-pagination-fraction{", "}"], {
  "position": "relative"
}, {
  "position": "absolute",
  "bottom": "14px",
  "left": "85%",
  "height": "fit-content",
  "width": "fit-content",
  "whiteSpace": "nowrap",
  "borderRadius": "50px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(167 167 167 / var(--tw-bg-opacity, 1))",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "fontSize": "1rem",
  "lineHeight": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
});
export const WrapperImage = styled.div.withConfig({
  displayName: "MobilePackshotstyle__WrapperImage",
  componentId: "sc-rnb2qz-1"
})(["", " img{", "}"], {
  "display": "flex",
  "justifyContent": "center",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))"
}, {
  "aspectRatio": "1 / 1",
  "height": "100%",
  "width": "100%",
  "objectFit": "contain",
  "objectPosition": "center"
});